module.exports = __webpack_public_path__ + "img/pending-img-3.01b417a2.jpg";